module.exports = __webpack_public_path__ + "media/character-baby-sad.7ecafd62.mp3";